import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { FinanceModel } from 'app/models/finance.model';
import { catchError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FinanceService extends BaseService<FinanceModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'finance');
    }

    summary(params: Record<string, unknown>) {
        return this.api.getSub<{
            months: Array<{
                year: number;
                month: number;
                totalTransactions: number;
                totalIncome: number;
                totalExpenses: number;
                totalIncomeCount: number;
                totalExpensesCount: number;
            }>;
        }>(`${this.endpoint}/summary`, params);
    }

    employeeMonthlyBalance(params?: { year?: number; month?: number; user_receiver_ids?: string | number[] }) {
        const query: Record<string, unknown> = {};
        if (params?.year != null) query.year = params.year;
        if (params?.month != null) query.month = params.month;
        if (params?.user_receiver_ids != null) {
            query.user_receiver_ids = Array.isArray(params.user_receiver_ids)
                ? params.user_receiver_ids.join(',')
                : params.user_receiver_ids;
        }
        return this.api.getSub<{
            year: number;
            month: number;
            items: Array<{ user_id: number; balance: number }>;
        }>(`${this.endpoint}/employee-monthly-balance`, query);
    }

    bulkUpdatePayment(data: { finance_ids: number[]; realized_payment_type: any; date_payed: any }) {
        const $request = this.api.postSub<any>(`${this.endpoint}/bulk-update-payment`, data).pipe(
            catchError((error) => {
                this.openDialogErro({
                    title: 'Erro ao Atualizar Pagamentos!!',
                    message: this.getErrorMessage(error),
                });
                throw error;
            }),
        );
        return this.withPromise($request);
    }

    createCommissionForPayment(financeId: number) {
        const $request = this.api.postSub<any>(`${this.endpoint}/${financeId}/create-commission`, {}).pipe(
            catchError((error) => {
                console.error('Erro ao criar comissão:', error);
                throw error;
            }),
        );
        return this.withPromise($request);
    }

    deleteFinance(financeId: number) {
        const $request = this.api.deleteSub<{ finance_id: number; deleted_commission_ids: number[] }>(`${this.endpoint}/${financeId}`).pipe(
            catchError((error) => {
                this.openDialogErro({
                    title: `Erro ao Deletar ${this.endpoint}!!`,
                    message: this.getErrorMessage(error),
                });
                throw error;
            }),
        );
        return this.withPromise($request);
    }
}
